<template>
    <template v-for="widget in widgets" :key="widget.component">
        <component :is="widget.component" v-bind="widget.data" />
    </template>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';

interface Widget {
    component: string;
    data: Record<string, any>;
    priority: number;
}

interface Props {
    name: string;
    // Optional: explicit widgets map (slot name → widget list). When provided
    // it overrides `$page.props.widgets`. Use this when the host component is
    // rendered outside the page-prop context — e.g. a modal populated via
    // AJAX response rather than an Inertia visit.
    widgets?: Record<string, Widget[]>;
}

const props = defineProps<Props>();

const $page = usePage();

const widgets = computed(() => {
    if (props.widgets && Object.keys(props.widgets).length > 0) {
        return props.widgets[props.name] || [];
    }
    const pageWidgets = ($page.props.widgets as Record<string, Widget[]> | undefined) || {};
    return pageWidgets[props.name] || [];
});
</script>
